import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'app-widget-pages-settings',
  templateUrl: './widget-pages-settings.component.html',
  styleUrls: ['./widget-pages-settings.component.css']
})
export class WidgetPagesSettingsComponent implements OnInit {
  @Output() done = new EventEmitter();
  @Input() visibility: any;
  @Input() simple_visibility: any;
  @Input() loading: any = false;
  @Input() mobile: any;
  objectKeys = Object.keys;

  is(type, obj) {
    const _class = Object.prototype.toString.call(obj).slice(8, -1);
    return obj !== undefined && obj !== null && _class === type;
  };

  capitalize(str) {
    return `${str.substring(0, 1).toUpperCase()}${str.substring(1, str.length).toLowerCase()}`
  };

  formatText(str) {
    return this.capitalize(str.replace(/_/g, ' '))
  }

  constructor() { }

  ngOnInit() {
  }

  submit() {
    if(!this.mobile.USE_PROFILE_SUMMARY_VIEW){
      this.done.emit({ ...this.visibility });
    }else{
      this.done.emit({ ...this.simple_visibility });
    }
    
  }
}
